/* ============================================================
   MC ENHANCE - progressive enhancement layer for MC Bespoke
   Loads after the React / Framer Motion app has hydrated.
   Everything is defensive: any failure is silent and the
   original experience is untouched.
   ============================================================ */
(function(){
  'use strict';
  var BOOKING = 'https://booking.appointy.com/MCBESPOKE';
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}

  /* ---- 0 - Client testimonials section removed ("In their words") ---- */
  var QUOTES_SEL = 'section[aria-label="Client words"]';
  try {
    var st = document.createElement('style');
    st.id = 'mce-no-quotes';
    st.textContent = QUOTES_SEL + '{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  } catch(e){}
  function dropQuotes(){
    var n = document.querySelectorAll(QUOTES_SEL), i;
    for (i = 0; i < n.length; i++){ if (n[i].parentNode) n[i].parentNode.removeChild(n[i]); }
  }

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    safe(dropQuotes);
    try {
      var mo = new MutationObserver(function(){ safe(dropQuotes); });
      mo.observe(document.documentElement, { childList:true, subtree:true });
      setTimeout(function(){ mo.disconnect(); safe(dropQuotes); }, 30000);
    } catch(e){}

    /* Give React time to hydrate before touching the DOM */
    setTimeout(function(){
      safe(dropQuotes);
      safe(grain); safe(progress);
      safe(spotlight); safe(ctaSheen); safe(stickyBar);
      safe(revealFailsafe);
      whenPreloaderGone(function(){ safe(counters); });
    }, 600);
  });

  function safe(fn){ try { fn(); } catch(e){ /* silent */ } }

  /* Wait until the app's white intro preloader has left the DOM,
     so the stat counters animate where the visitor can see them. */
  function whenPreloaderGone(cb){
    var pre = null;
    try {
      pre = [].slice.call(document.querySelectorAll('div')).filter(function(e){
        var cs = window.getComputedStyle(e);
        return cs.position === 'fixed' && cs.backgroundColor === 'rgb(255, 255, 255)' &&
               e.offsetWidth >= window.innerWidth * 0.9 && e.offsetHeight >= window.innerHeight * 0.9;
      })[0] || null;
    } catch(e){}
    if (!pre){ cb(); return; }
    var waited = 0;
    var t = setInterval(function(){
      waited += 250;
      var gone = !document.body.contains(pre);
      if (!gone){
        var cs = window.getComputedStyle(pre);
        gone = cs.display === 'none' || parseFloat(cs.opacity) < 0.05 || cs.visibility === 'hidden';
      }
      if (gone || waited > 20000){ clearInterval(t); setTimeout(cb, 250); }
    }, 250);
  }

  /* ---- 1 - Film grain overlay ---- */
  function grain(){
    var d = document.createElement('div');
    d.className = 'mce-grain';
    d.setAttribute('aria-hidden','true');
    document.body.appendChild(d);
  }

  /* ---- 2 - Scroll progress hairline ---- */
  function progress(){
    var bar = document.createElement('div');
    bar.className = 'mce-progress';
    bar.setAttribute('aria-hidden','true');
    document.body.appendChild(bar);
    var ticking = false;
    function update(){
      ticking = false;
      var h = document.documentElement;
      var max = (Math.max(h.scrollHeight, document.body.scrollHeight) - h.clientHeight) || 1;
      var y = window.scrollY || h.scrollTop || document.body.scrollTop || 0;
      var p = Math.min(1, Math.max(0, y / max));
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    function onScroll(){
      if (!ticking){ ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    document.addEventListener('scroll', onScroll, { passive:true, capture:true });
    update();
  }

  /* ---- 3 - Animated stat counters (hero) ---- */
  function counters(){
    var top = document.getElementById('top');
    if (!top) return;
    var leaves = [].filter.call(top.querySelectorAll('*'), function(el){
      return el.children.length === 0 && /^\d+\+$/.test((el.textContent||"").trim());
    });
    if (!leaves.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        run(en.target);
      });
    }, { threshold: 0.4 });
    leaves.forEach(function(el){ io.observe(el); });
    function run(el){
      var final = (el.textContent||"").trim();
      var n = parseInt(final, 10);
      if (!n || reduced){ return; }
      var t0 = null, DUR = 1500;
      function ease(t){ return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }
      function frame(ts){
        if (!t0) t0 = ts;
        var t = Math.min(1, (ts - t0) / DUR);
        var v = Math.round(ease(t) * n);
        el.textContent = v + '+';
        if (t < 1) requestAnimationFrame(frame);
        else el.textContent = final;
      }
      el.textContent = '0+';
      requestAnimationFrame(frame);
    }
  }

  /* ---- 4 - Spotlight hover on large cards (21st.dev style) ---- */
  function spotlight(){
    if (reduced) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var candidates = [].slice.call(document.querySelectorAll('a, article'))
      .filter(function(el){
        if (el.closest('header') || el.closest('nav')) return false;
        var w = el.offsetWidth, h = el.offsetHeight;
        if (w < 230 || h < 180 || w > 900) return false;
        var cs = window.getComputedStyle(el);
        if (parseFloat(cs.borderRadius) < 8) return false;
        if (cs.position === 'static') el.style.position = 'relative';
        return true;
      })
      .slice(0, 30);
    candidates.forEach(function(el){
      el.classList.add('mce-spot');
      el.addEventListener('pointermove', function(e){
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mce-x', (e.clientX - r.left) + 'px');
        el.style.setProperty('--mce-y', (e.clientY - r.top) + 'px');
      }, { passive:true });
    });
  }

  /* ---- 5 - Sheen sweep on booking pill CTAs ---- */
  function ctaSheen(){
    if (reduced) return;
    var links = [].slice.call(document.querySelectorAll('a[href*="appointy"]'))
      .filter(function(el){
        var h = el.offsetHeight;
        return h >= 34 && h <= 90 && el.offsetWidth <= 420;
      })
      .slice(0, 8);
    links.forEach(function(el){ el.classList.add('mce-cta'); });
  }

  /* ---- 6 - Sticky mobile booking bar ---- */
  function stickyBar(){
    var bar = document.createElement('div');
    bar.className = 'mce-sticky';
    bar.innerHTML =
      '<span class="mce-sticky-txt"><strong>Private fittings, worldwide</strong>By appointment only</span>' +
      '<a class="mce-sticky-btn" href="' + BOOKING + '" target="_blank" rel="noopener">Book a fitting</a>';
    document.body.appendChild(bar);
    var appt = document.getElementById('appointment');
    var nearEnd = false;
    if (appt && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        nearEnd = entries[0].isIntersecting;
        refresh();
      }, { threshold: 0.15 }).observe(appt);
    }
    var ticking = false;
    function refresh(){
      ticking = false;
      var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var show = (y > window.innerHeight * 0.85) && !nearEnd;
      bar.classList.toggle('is-on', show);
    }
    function onScroll(){
      if (!ticking){ ticking = true; requestAnimationFrame(refresh); }
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    document.addEventListener('scroll', onScroll, { passive:true, capture:true });
    refresh();
  }

  /* ---- 7 - Reveal failsafe ----------------------------------
     The app reveals its sections with Framer Motion whileInView,
     layered on top of Lenis smooth scrolling. If either desyncs -
     slow hydration, a JS error, a browser that fights Lenis - the
     elements keep their initial inline opacity:0 and the section
     never appears at all. Watch for that and force the end state.
     The check repeats while the element is on screen, because the
     app's opacity can flicker mid-scroll and a one-shot test would
     miss it. Only elements whose inline initial state was opacity:0
     are watched, and those always target 1 - so anything still
     below 90% after ~2.4s on screen is a reveal that failed, half
     as often as it stalls outright.
     ----------------------------------------------------------- */
  function revealFailsafe(){
    var FIRST = 3;      // skip the first ticks: let a real animation run
    var LIMIT = 15;     // stop watching an element after ~12s on screen
    var TICK  = 800;
    var FLOOR = 0.9;    // a reveal that targets 1 and sits below this failed
    var timers = new WeakMap();

    function hiddenInline(el){
      return /opacity:\s*0(\D|$)/.test(el.getAttribute('style') || '');
    }

    function force(el){
      /* !important is required: a plain inline opacity:1 is still
         overridden here and the element stays invisible. Verified
         on the live page before shipping this. */
      el.style.setProperty('transition', 'opacity 420ms ease, transform 420ms ease');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('transform', 'none', 'important');
      el.setAttribute('data-mce-forced', '1');
    }

    function disarm(el){
      var id = timers.get(el);
      if (id){ clearInterval(id); timers['delete'](el); }
    }

    function arm(el){
      if (timers.has(el)) return;
      var tries = 0;
      timers.set(el, setInterval(function(){
        tries++;
        if (!document.body.contains(el)){ disarm(el); return; }
        if (tries >= FIRST && parseFloat(window.getComputedStyle(el).opacity) < FLOOR){
          force(el); disarm(el); io.unobserve(el); return;
        }
        if (tries >= LIMIT) disarm(el);
      }, TICK));
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) arm(en.target);
        else disarm(en.target);
      });
    }, { threshold: 0.15 });

    function scan(){
      var nodes = document.querySelectorAll('main [style*="opacity"]'), i, el;
      for (i = 0; i < nodes.length; i++){
        el = nodes[i];
        if (el.hasAttribute('data-mce-watch')) continue;
        if (el.hasAttribute('data-mce-forced')) continue;
        if (!hiddenInline(el)) continue;
        if (el.offsetWidth < 60 || el.offsetHeight < 60) continue;
        if (window.getComputedStyle(el).position === 'fixed') continue;
        el.setAttribute('data-mce-watch', '1');
        io.observe(el);
      }
    }

    scan();
    try {
      var mo = new MutationObserver(function(){ safe(scan); });
      mo.observe(document.body, { childList:true, subtree:true, attributeFilter:['style'] });
      setTimeout(function(){ mo.disconnect(); }, 60000);
    } catch(e){}
  }
})();